import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { H2, LI, P, UL } from "../../components/PolicyPage";

export default function Shipping() {
  return (
    <PolicyPage
      slug="shipping-delivery"
      title="Shipping & Delivery"
      updated="June 2026"
      seoDescription="How NQ Springs & 4x4 Accessories ships surplus 4WD parts Australia-wide from Townsville: dispatch times, carriers, freight costs, pickup and bulky items."
      intro="We ship Australia-wide from our Garbutt workshop in Townsville, and you are welcome to collect in person."
    >
      <section>
        <H2>Dispatch times</H2>
        <UL>
          <LI>Orders placed before 2pm on a business day are usually packed the same day, otherwise the next business day.</LI>
          <LI>Allow 1-2 business days for dispatch during busy periods. We will call or email if anything will take longer.</LI>
          <LI>We do not dispatch on weekends or Queensland public holidays.</LI>
        </UL>
      </section>

      <section>
        <H2>Carriers and delivery estimates</H2>
        <P>
          We use Australia Post and road freight carriers depending on size and weight. Once your
          parcel leaves us the delivery time is in the carrier's hands. Typical times after dispatch:
        </P>
        <UL>
          <LI>Townsville and North Queensland: 1-3 business days</LI>
          <LI>Brisbane, Sydney, Melbourne and other capitals: 3-6 business days</LI>
          <LI>Regional, remote and WA/NT: 5-10 business days</LI>
        </UL>
        <P>
          These are estimates, not guarantees. Wet season weather in the north can add time and we
          will keep you posted if we hear of a hold-up.
        </P>
      </section>

      <section>
        <H2>Freight costs</H2>
        <UL>
          <LI>Freight is calculated at checkout: standard or express, based on your order.</LI>
          <LI>Free standard shipping on orders over $300.</LI>
          <LI>Pickup from 321 Ingham Rd, Garbutt QLD 4814 is free - choose it at checkout and we will message you when it is ready.</LI>
        </UL>
      </section>

      <section>
        <H2>Bulky and oversized items</H2>
        <P>
          Leaf springs, long shocks, bar work and complete kits are oversized freight. If your order
          needs a freight quote we will contact you before charging anything extra, and you can
          cancel for a full refund if the quote does not suit. Nothing is ever shipped with a
          surprise bill attached.
        </P>
      </section>

      <section>
        <H2>Addresses, tracking and lost parcels</H2>
        <UL>
          <LI>Check your address carefully at checkout. We cannot redirect a parcel once it is with the carrier, and re-delivery costs are yours.</LI>
          <LI>Tracking is emailed when we dispatch. If tracking has not moved for 5 business days, contact us and we will chase the carrier.</LI>
          <LI>If a parcel is lost or arrives damaged we will replace or refund it - see <Link to="/returns-refunds" className="gold-text font-semibold">Returns & Refunds</Link>.</LI>
          <LI>We ship within Australia only.</LI>
        </UL>
      </section>
    </PolicyPage>
  );
}
